import type Mithril from 'mithril';
import Component from 'flarum/common/Component';
import { truncate } from 'flarum/common/utils/string';
import Discussion from 'flarum/common/models/Discussion';
import Post from 'flarum/common/models/Post';

export interface DiscussionExcerptAttrs {
  discussion: Discussion;
}

export default class DiscussionExcerpt extends Component<DiscussionExcerptAttrs> {
  isShowAll = false;

  oninit(vnode: Mithril.Vnode<DiscussionExcerptAttrs, this>) {
    super.oninit(vnode);
  }

  handleClick(post: Post, discussion: Discussion) {
    const contentElement = document.getElementById(`Discussion-${discussion.id()}-excerpt-content`);
    const collapsedElement = document.getElementById(`Discussion-${discussion.id()}-excerpt-collapsed`);
    if (!contentElement || !collapsedElement) return;
    if (contentElement.getAttribute('show-all') === 'true') {
      contentElement.innerHTML = truncate(post.contentPlain() || '', 150);
      contentElement.setAttribute('show-all', 'false');
      collapsedElement.style.marginLeft = '4px';
      collapsedElement.firstChild!.textContent = '阅读全文';
      (collapsedElement.lastChild as HTMLElement).style.transform = '';
      this.isShowAll = false;
    } else {
      contentElement.innerHTML = `<div class="Post-body">${post.contentHtml()}</div>`;
      contentElement.setAttribute('show-all', 'true');
      collapsedElement.style.marginLeft = '0px';
      collapsedElement.firstChild!.textContent = '收起';
      (collapsedElement.lastChild as HTMLElement).style.transform = 'rotateX(180deg)';
      this.isShowAll = true;
    }
  }

  view(vnode: Mithril.Vnode<DiscussionExcerptAttrs, this>) {
    const { discussion } = this.attrs;
    const firstPost = discussion.firstPost();

    if (!firstPost) return null;

    const contentPlain = firstPost.contentPlain();

    if (!contentPlain) return null;

    if (contentPlain.length > 150) {
      return (
        <div>
          <span
            id={`Discussion-${discussion.id()}-excerpt-content`}
            className="DiscussionListItem-excerpt-content"
            show-all="false"
            onclick={(e) => {
              e.stopPropagation();
              if (this.isShowAll) return;
              this.handleClick(firstPost, discussion);
            }}
          >
            {truncate(contentPlain, 150)}
          </span>
          <span
            id={`Discussion-${discussion.id()}-excerpt-collapsed`}
            className="DiscussionListItem-excerpt-collapsed"
            onclick={(e) => {
              e.stopPropagation();
              this.handleClick(firstPost, discussion);
            }}
          >
            阅读全文
            <svg width="16" height="16" viewBox="0 0 24 24" class="Zi Zi--ArrowDown ContentItem-arrowIcon" fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M17.776 10.517a.875.875 0 0 1-.248 1.212l-5.05 3.335a.875.875 0 0 1-.964 0L6.47 11.73a.875.875 0 1 1 .965-1.46l4.56 3.015 4.568-3.016a.875.875 0 0 1 1.212.248Z"
                clip-rule="evenodd"
              ></path>
            </svg>
          </span>
        </div>
      );
    } else {
      return <span>{truncate(contentPlain, 150)}</span>;
    }
  }
}
